var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("吉林音像出版社")]),_c('div',{staticClass:"tg-sectionhead"},[_c('div',[_vm._v("联系电话:0431-81629660")])])])}]

export { render, staticRenderFns }